import customerComponent from './customer.component';
import CustomerCreate from './create'
import CustomerEdit from './edit'
import CustomerAll from './all'
import ServiceOptionComponent from './common/service_options/service_option.component'

let customerModule = angular.module('customer', [
    CustomerCreate,
    CustomerEdit,
    CustomerAll
])

  .component('customer', customerComponent)
  .component('serviceOption', ServiceOptionComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('customer.edit', {
        url: '/edit/:id',
        component: 'customeredit',
        data: {
          requireACL: 'tnt_billing_customer.edit'
        }
      })

      .state('customer.create', {
        url: '/create',
        component: 'customercreate',
        data: {
          requireACL: 'tnt_billing_customer.create'
        }
      })

      .state('customer.all', {
        url: '/all/:page',
        component: 'customerall',
        data: {
          requireACL: 'tnt_billing_customer.view'
        }        
      })
  })

  .name;

export default customerModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/index.js